import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ExportPayload, PersonSearchService } from 'src/app/_services/person-search.service';
import { StatsMatrixHandlerService } from 'src/app/_services/stats-matrix-handler.service';
import { JdDataService } from 'src/app/jd-data.service';

@Component({
    selector: 'app-insights-sidebar',
    templateUrl: './insights-sidebar.component.html',
    styleUrls: ['./insights-sidebar.component.scss'],
    standalone: false
})
export class InsightsSidebarComponent implements OnInit {

  @Input() showSummary: boolean;
  quicksearchdata: any = {};
  aidata: string = '';
  showshimmerloader: boolean = false;
  aisubscription: Subscription;
  totalResultsCount: number = 0;
  totalTenureMedian: number = 0;
  changedJobs: number = 0;
  @ViewChild('viewMoreSummary') viewMoreSummary: TemplateRef<any>;
  projectDetails: any = {};
  insightsExportSubscription: Subscription = null;
  successMessage: string = '';
  errorMessage: string = '';
  projectnumber: string = '';
  subscriptions: Array<Subscription> = [];
  summarySubscription: Subscription;
  projectDetailsSubscription: Subscription;

  constructor(
    private router: Router,
    private aiSourcingHandlerService: AiSourcingHandlerService,
    private aiSourcingService: AiSourcingService,
    private aggregationservice: AggregationService,
    private personsearchservice: PersonSearchService,
    private modelService: NgbModal,
    private statsMatrixHandlerService: StatsMatrixHandlerService, private jdDataService: JdDataService,
    private filterDataHandlerService: FilterDataHandlerService
  ) { }

  ngOnInit() {
  //  this.summarySubscription = this.aiSourcingService.getInsightsAiEvent.subscribe(data => { this.getAiSummaryData(data) });
    this.subscriptions.push(this.summarySubscription);
    this.projectnumber = window.location.pathname?.split('/')[3];

    this.projectDetailsSubscription = this.aiSourcingService.getProjectDetailsEvent.subscribe((res: string) => {
      this.projectDetails = res;
    });
    this.subscriptions.push(this.projectDetailsSubscription);

    // this.insightsExportSubscription = this.personsearchservice.insightsExportDataEvent.subscribe((payloadData: ExportPayload) => {
    //   this.exportToPDF(payloadData);
    // });
    this.subscriptions.push(this.insightsExportSubscription);
    this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;
  }

  backEvent() {
    this.aiSourcingHandlerService.setDisplayPageEvent('project-details');
    this.router.navigate(['/ai-sourcing/project-list']);
  };

  // getAiSummaryData(event: any) {
  //   if (event) {
  //     this.totalResultsCount = event.totalResultsCount || 0;
  //     this.totalTenureMedian = event.totalmedianTenure || 0;
  //     this.changedJobs = event.changedJobs || 0;
  //     const locations = event.topLocations.map(elm => ({ Location: elm.key, 'Talent Count': elm.doc_count }));
  //     const companies = event.dataSourceCurrentCompany && event.dataSourceCurrentCompany.data.map(elm => ({ Company: elm.label, 'Talent Count': elm.value }));
  //     const industries = event.currentIndustry && event.currentIndustry.map(elm => ({ Industry: elm.key, 'Talent Count': elm.doc_count }));
  //     const schools = event.school && event.school.map(elm => ({ Schools: elm.key, 'Talent Count': elm.doc_count }));
  //     const fieldofstudies = event.fieldOfStudy && event.fieldOfStudy.map(elm => ({ 'Field of Study': elm.key, 'Talent Count': elm.doc_count }));
  //     const skills = event.skills && event.skills.map(elm => ({ 'Skills': elm.key, 'Talent Count': elm.doc_count }));
  //     const jobtitles = event.titles && event.titles.map(elm => ({ 'Job Title': elm.key, 'Talent Count': elm.doc_count }));
  //     const totaltenure = event.dataSourceCurrentExperience && event.dataSourceCurrentExperience.data && event.dataSourceCurrentExperience.data.map(elm => ({ 'Total Tenure': elm.label, 'Talent Count': elm.value }))
  //     const currenttenure = event.dataSourceExpInCurrentRole && event.dataSourceExpInCurrentRole.data && event.dataSourceExpInCurrentRole.data.map(elm => ({ 'Tenure in current company': elm.label, 'Talent Count': elm.value }))
  //     const seniority = event.dataSourceSeniority && event.dataSourceSeniority.data && event.dataSourceSeniority.data.map(elm => ({ 'Seniority': elm.label, 'Talent Count': elm.value }))
  //     const nationality = event?.dataSourceNationality && event.dataSourceNationality.data.map(ele => ({ Nationality: ele.label, 'Talent Count': ele.value + '%' }));
  //     const ethnicity = event?.dataSourceEthnicity && event.dataSourceEthnicity.data.map(ele => ({ Ethnicity: ele.label, 'Talent Count': ele.value + '%' }));

  //     this.quicksearchdata = {
  //       locations: locations,
  //       companies: companies,
  //       industries: industries,
  //       schools: schools,
  //       fieldofstudies: fieldofstudies,
  //       skills: skills,
  //       jobtitles: jobtitles,
  //       totaltenures: totaltenure,
  //       currenttenures: currenttenure,
  //       seniority: seniority,
  //       nationality: nationality,
  //       ethnicity: ethnicity

  //     }
  //   }
  //   debugger
  //   this.aggregationservice.getStatsAggsAISourcing(this.projectnumber);

  // }

  generateai() {
    this.showshimmerloader = true;
    this.aidata = '';
    const payload = {
      data: this.quicksearchdata,
      filters: {},
      totaltenuremedian: this.totalTenureMedian,
      talentcount: this.totalResultsCount,
      changedjobscount: this.changedJobs,
      changedjobsdurationinmonths: 12,
      booleanquery: '*'
    }
    this.aisubscription = this.personsearchservice.getquicksearchsummary(payload).subscribe((res: any) => {
      this.aidata = res.data;
      this.showshimmerloader = false
      this.aidata = this.aidata.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    })
  }

  openViewMore() {
    this.modelService.open(this.viewMoreSummary, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

    // this.viewMore2 = !this.viewMore2;
    // if (this.viewMore2) {
    //   this.generateai();
  }

  dismiss() {
    this.modelService.dismissAll();
  }

  /**
* Request insights export from currently active tab
*/
  requestInsightsExport() {
    this.personsearchservice.sendInsightsExportRequest({ type: 'SIGNAL', action: '', data: { currentTab: 'insights' } });
  }

  exportToPDF(payloadData: any) {
    const filtersData = this.aggregationservice.getRequestWithFilters();
    // const sharedReqData = this.aggReqObjectHandlerService.getSharedRequestObject();
    const matrixData = this.statsMatrixHandlerService.matrixStaticData;
    matrixData['medianTenure'] = GlobalService.convertNumberToYearsAndMonths(matrixData.totalMedianTanureCount);
    matrixData['talentCount'] = GlobalService.formatNumberToIndianFormat(this.totalResultsCount);
    // remove "searchastext" from filter data, excluded filters & perform basic transformations/changes
    // const excludedJobtitles = sharedReqData?.exclude_jobtitles?.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean) || [];
    // const excludedLocations = sharedReqData?.exclude_locations?.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean) || [];
    // const mandatorySkills = sharedReqData?.mandatoryskills?.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean) || [];
    // Object.entries(filtersData).forEach(([key, value]) => {
    //   if(value && Array.isArray(value)) {
    //     filtersData[key] = (Array.isArray(value) ? value : [value]).filter(Boolean).map((s) =>
    //     {
    //       if (typeof s === 'string') {
    //         if (s.includes('.searchastext')) {
    //           return s.split('.searchastext')[0];
    //         } else {
    //           return s.split('.aisearch')[0];
    //         }
    //       } else {
    //         if (s.key.includes('.searchastext')) {
    //           return s.key.split('.searchastext')[0];
    //         } else {
    //           return s.key.split('.aisearch')[0];
    //         }
    //       }
    //     });

    //     if(key === 'seniority' || key === 'companysize'){
    //       filtersData[key] = filtersData[key].filter(item => (item.toLowerCase() != 'all'));
    //     } else if(key === 'jobTitleSelectedList') {
    //       filtersData[key] = filtersData[key].filter(item => !excludedJobtitles.includes(item.toLowerCase()));
    //     } else if(key === 'locationSelectedList') {
    //       filtersData[key] = filtersData[key].filter(item => !excludedLocations.includes(item.toLowerCase()));
    //     } else if(key === 'skillsSelectedList') {
    //       filtersData[key] = filtersData[key].map(item => {
    //         const updatedSkillObj = { key: item };
    //         if(mandatorySkills.includes(item.toLowerCase())) {
    //           updatedSkillObj['isMandatory'] = true;
    //         } else {
    //           updatedSkillObj['isMandatory'] = false;
    //         }
    //         return updatedSkillObj;
    //       });
    //     }
    //   }
    // });

    // handle male/female change to men/women
    if (filtersData?.['gender']?.toLowerCase() == 'male') filtersData['gender'] = 'Men';
    else if (filtersData?.['gender']?.toLowerCase() == 'female') filtersData['gender'] = 'Women';

    //Continent sent in export payoload for talent-insights
    filtersData.continentstobeincluded = (Array.isArray(payloadData.continentstobeincluded) ? payloadData.continentstobeincluded : [payloadData.continentstobeincluded]).filter(Boolean);
    delete payloadData.continentstobeincluded;

    filtersData['JD_KEYS'] = this.jdDataService.jdDataFromSession;



    const payloadForExport: ExportPayload = {
      data: {
        ...payloadData,
        filters: filtersData,
        matrixData: matrixData
      }
    }
    if (this.aidata) {
      payloadForExport.data['aiData'] = this.aidata;
    } else {
      payloadForExport.data['aiData'] = null;
      payloadForExport.data['aiRequestFilters'] = [];
      payloadForExport.data['aiRequestPayload'] = this.quicksearchdata || {};
    }

    // service call for export
    this.personsearchservice.exportInsightsToPDFReport(payloadForExport).subscribe((res: any) => {
      if (res) {
        if (res.status === 'failure') {
          this.errorMessage = 'Error occured while generating the report';
        } else {
          this.successMessage = 'You will receive the person-search insights report on your email in a min.';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      } else {
        this.errorMessage = 'Error occured while generating the report';
      }
    }, () => {
      this.errorMessage = 'Error occured while generating the report';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }

  ngOnDestroy() {
    if (this.aisubscription) {
      this.aisubscription.unsubscribe();
    }
    // this.subscriptions.forEach(sub => sub.unsubscribe());

  }

  /**
  * Method to redirect on blog page
  */
  learnMoreDetails() {
    window.open('https://fire-crib-a04.notion.site/Actions-Post-Results-264d71872fa58027bb8fc0fefabff9dd');
  };
}


